'use es6';

import get from 'transmute/get';
export const getMessageEditorStaging = state => {
  return get('messageEditorStaging', state);
};